// src/App.js
import React, { useLayoutEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import LandingPage from './pages/LandingPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import UserPolicy from './pages/UserPolicy';
import './styles/main.scss';
import useDeviceTypeDetector from './hooks/useDeviceTypeDetector';
function App() {
  const { deviceType } = useDeviceTypeDetector();

  useLayoutEffect(() => {
    document.body.className = deviceType;
  }, [deviceType]);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/user-policy" element={<UserPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
